<template>
	<section class="page">

		<div class="list">
			<div>
				<div style="text-align:center;">
					<h1 style="text-align:center;font-weight:bold;font-size:30px;margin-top:20px">{{list.title}}</h1>
				</div>
				<div style="text-align:center;font-size:16px;margin-bottom:0px;margin-top:20px;">
					<span v-if="list.sender" style="margin-top:20px;">
						发送人： {{list.sender.name}}
					</span>
					<span style="padding-left:10px;">{{list.add_time_str}}</span>
				</div>
				
				<div class="poster_content" style="font-size:16px" contenteditable="false">
					<el-button type="text" v-if="is_admin || list.forward" style="font-size:16px" @click="sendeeVisible=true">查看阅读情况</el-button>
					<p contenteditable="false" v-html="list.content"></p>
			
					<img :src="img.path" v-for="(img,index1) in list.images" :key="index1" 
						style="width:100%;height:auto" ></img>

					<p v-if="list.link&&list.link.indexOf('http')!=-1" style="text-align:right;fint-size:12px">
						<span>链接到</span><a :href="list.link" target="blank">{{list.link}}</a>
					</p>
				</div>
				<div v-if="list.attachment && list.attachment.length>0" class="attachment">
					<span>附件：</span>
					<span class="file" v-for="(item,index) in list.attachment" :key="item.id">
						<a :key="index" :href="item.path+'?attname='+item.name" target="blank"> <i
								class="el-icon-download"></i>{{item.name }}；</a>
					</span>
				</div>
			</div>
		</div>
		<sendee-list  v-if="sendeeVisible" :id="id" :is_admin="is_admin" @close="sendeeVisible=false"/>

	</section>
</template>

<script>
	import { oa_notice } from "@/api/education";
	import { poster } from "@/api/server";

	import formatter from '@/mixins/formatter'
	import SendeeList from './sendee-list.vue';

	export default {

		mixins: [formatter],
		data() {
			return {
				typeList: {
					'WEEKPLAN': '周计划',
					'RECIPES': '食谱',
				},
				sendeeVisible:false,
				list: {},
				Visible: false,
				id: null,
				is_admin: false
			}
		},
		methods: {

			getDetail(data) {
				oa_notice.get({ id: this.id }).then(res => {
					if (res.data) {
						this.list = res.data;
						this.list.add_time_str = this.timeFormatter(this.list.add_time);
					}
				});
			},

			back() {
				this.$router.go(-1); //返回上一层
			},
		},
		components: { SendeeList },
		mounted() {
			this.id = this.$route.query.id
			this.is_admin = this.$route.query.is_admin
			oa_notice.read({ id: this.id }).then(res => {
				this.getDetail();

			});

		}
	};
</script>

<style lang="scss" scoped>
	.list {
		text-align: left;
		width: 800px;
		background-color: white;
	}
	.page {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: white;
	}
	.poster_content {
		padding: 30px;
	}

	.attachment {
		padding: 30px;
		span + span {
			margin-left: 20px;
		}
	}
	.avatar {
		width: 24px;
		height: 24px;
		border-radius: 20px;
		vertical-align: middle;
		display: inline-block;
		margin-right: 6px;
	}

	.cell {
		padding-left: 5px;
		padding-right: 5px;
		font-size: 12;
		color: -internal-quirk-inherit;
	}
	.read-user-list {
		margin: 2px;
		display: flex;
		flex-wrap: wrap;
		padding-top: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/notice/detail.vue